<template>
  <div class="text-center">
    <b-carousel class="carousel"
                controls
                background="#FFF"
                img-width="100px"
                img-height="100px"
                :interval="8000">

      <div class="carousel-item" v-for="image in introImg.images" :key="image">
        <img :src="backendUrl+introImg.basepath+image"/>
      </div>
    </b-carousel>
    <div v-html="introduction"></div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Template',
  data: function(){
    return {
      introduction: '',
      introImg: '',
      backendUrl: Vue.$backend.getBackendUrl(),
    }
  },
  created: function(){
    Vue.$backend.getHomepageIntroduction().then(res => this.introduction = res.text)
    Vue.$backend.getHomepageIntroductionImages().then(res => this.introImg = res)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.carousel{
  height: 200px;
  width: 100%;
  overflow: hidden;
}
.carousel-item {
  outline: none;
}
.carousel-item img{
  height: 180px;
  width: auto;
}

</style>
